import { motion } from "framer-motion";
import CTAButton from '../CTAButton';

const ExecutionFramework = ({ steps, onCtaClick }) => {
    return (
        <section className="py-10 bg-[#01014C]">
            <div className="container mx-auto px-6">
                <div className="max-w-3xl mx-auto text-center mb-16">
                    <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 syne">Our Strategic <span className="text-blue-400">Execution Framework</span></h2>
                    <p className="text-blue-100 text-sm md:text-base leading-relaxed">
                        A structured, step-by-step approach to aligning talent strategy with your organizational growth objectives.
                    </p>
                </div>
                <div className="relative border-l border-white/10 ml-4 md:ml-0 md:border-none">
                    <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-white/10 -translate-x-1/2" />
                    {steps.map((step, i) => (
                        <div key={i} className={`relative flex items-center mb-10 w-full ${i % 2 === 0 ? 'md:flex-row-reverse' : ''}`}>
                            <div className="md:w-1/2" />
                            <div className="absolute left-[-16px] md:left-1/2 w-8 h-8 bg-blue-600 rounded-lg shadow-[0_0_20px_rgba(37,99,235,0.5)] z-10 -translate-x-1/2 flex items-center justify-center text-[10px] text-white font-black">0{i+1}</div>
                            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} className="md:w-1/2 pl-10 md:px-16">
                                <h4 className="text-blue-400 font-bold uppercase text-xs tracking-widest mb-3">{step.title}</h4>
                                <p className="text-white  text-lg!">{step.description}</p>
                            </motion.div>
                        </div>
                    ))}
                </div>

                {onCtaClick && (
                    <div className="mt-16 text-center flex justify-center">
                        <CTAButton text="Discuss Your Implementation Plan" onClick={onCtaClick} />
                    </div>
                )}
            </div>
        </section>
    );
};
export default ExecutionFramework